import { TConnector, TField, TProductCategory, TSubmodel } from '../model';


export const isItemSelected = (
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null,
    itemId: string | null | undefined,
): boolean => {
    if (!itemId || selectedItem == null) return false;
    if (!('id' in selectedItem)) return false;
    return selectedItem.id === itemId;
};

export const pickNextSiblingIndex = (
    deletedIndex: number,
    remainingLength: number,
): number => {
    if (remainingLength <= 0) return -1;
    if (deletedIndex < 0) return 0;
    return Math.min(deletedIndex, remainingLength - 1);
};
